import { useEffect, useState, useCallback } from "react";

/**
 * A drop-in replacement for useState that syncs to localStorage.
 * Guarantees form data survives accidental refreshes.
 *
 * @param {string} key - unique storage key (e.g. "form:new-project")
 * @param {*} initial - default value if nothing stored yet
 */
export function usePersistedState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw !== null) return JSON.parse(raw);
    } catch {}
    return typeof initial === "function" ? initial() : initial;
  });

  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
  }, [key, value]);

  const clear = useCallback(() => {
    try { localStorage.removeItem(key); } catch {}
  }, [key]);

  return [value, setValue, clear];
}
